import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=30aaeb32&scoped=true"
import script from "./task-detail.vue?vue&type=script&lang=js"
export * from "./task-detail.vue?vue&type=script&lang=js"
import style0 from "./task-detail.vue?vue&type=style&index=0&id=30aaeb32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aaeb32",
  null
  
)

export default component.exports